export default "__VITE_ASSET__Bd3IoWvU__"